

export const BASE_URL = "https://notion-as-cms-backend.vercel.app/api/notion/"